import { Form, FormItemProps } from 'antd';
import styles from './BaseFormItem.module.scss';

const BaseFormItemComponent = <Values,>({
  className,
  ...props
}: FormItemProps<Values>) => (
  <Form.Item
    className={[styles.item, className].filter(Boolean).join(' ')}
    {...props}
  />
);

export const BaseFormItem = Object.assign(BaseFormItemComponent, {
  useStatus: Form.Item.useStatus,
});
